module.exports = __webpack_public_path__ + "img/zmcq.62638a29.jpg";